module.exports = __webpack_public_path__ + "img/CliSet4.1e654e98.jpg";